import { ApiClientService, DefaultTokenService } from '@dfl/react-security';
import Routes from 'routes';
import { SELECTED_LANGUAGE_KEY } from 'settings/i18n';

ApiClientService.setup({
  TokenService: DefaultTokenService,
});

ApiClientService.getInterceptors().request.use((config) => {
  config.headers = config.headers || {};

  try {
    const selectedLanguage = typeof window !== 'undefined' ? window.localStorage?.getItem(SELECTED_LANGUAGE_KEY) : null;

    if (selectedLanguage && !config.headers['accept-language']) {
      config.headers['accept-language'] = selectedLanguage;
    } else if (!selectedLanguage && !config.headers['accept-language']) {
      config.headers['accept-language'] = 'es';
    }
  } catch (error) {
    console.error('Error getting the language from localStorage:', error);
    if (!config.headers['accept-language']) {
      config.headers['accept-language'] = 'es';
    }
  }

  return config;
});

const App = () => {
  return <Routes />;
};

export default App;
